/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductCertificateUrlQueryResponse, GetShowProductCertificateUrlPathParams, GetShowProductCertificateUrl404 } from "../../models/GetShowProductCertificateUrl";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductCertificateUrlUrl({ productCode }: { productCode: GetShowProductCertificateUrlPathParams["productCode"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${productCode}/certificate-url` as const }  
  return res
}

/**
 * {@link /api/v1/products/:productCode/certificate-url}
 */
export async function getShowProductCertificateUrl({ productCode }: { productCode: GetShowProductCertificateUrlPathParams["productCode"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductCertificateUrlQueryResponse, ResponseErrorConfig<GetShowProductCertificateUrl404>, unknown>({ method : "GET", url : getGetShowProductCertificateUrlUrl({ productCode }).url.toString(), ... requestConfig })  
  return res.data
}